import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = ({ whatsapp }) => (
    <footer data-testid="site-footer" className="border-t border-[#27272A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-3">
                <Logo size={24} />
                <span className="font-display font-bold uppercase tracking-tight text-sm">
                    Campo <span className="text-[#FF6A00]">&</span> Concreto
                </span>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
                <a
                    data-testid="footer-instagram"
                    href="https://instagram.com/campoconcreto"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#A1A1AA] hover:text-[#FF6A00] transition-colors"
                >
                    <Instagram size={16} /> @campoconcreto
                </a>
                {whatsapp && (
                    <span
                        data-testid="footer-whatsapp"
                        className="font-mono text-xs uppercase tracking-[0.2em] text-[#A1A1AA]"
                    >
                        WhatsApp +{whatsapp}
                    </span>
                )}
            </div>
            <div className="flex items-center gap-4">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#52525B]">
                    © 2026 Campo & Concreto
                </p>
                <Link
                    data-testid="footer-admin-link"
                    to="/admin"
                    className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#3F3F46] hover:text-[#A1A1AA] transition-colors"
                >
                    Admin
                </Link>
            </div>
        </div>
    </footer>
);
